/** Matches backend enterprise slug derivation (hyphen-separated). */
function nameToSlug(name: string): string {
  return name
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

export const enterpriseLogic = {
  nameToSlug
};

export const DEFAULT_TEAM_ICON_COLOR = '#FDE047';
